import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { TooltipPosition } from 'ui-components/prop-types/tooltip-position';
import { useMaxZ } from 'ui-components/hooks/services/use-max-z';
import { ResponsiveWidth } from 'ui-components/components/responsive-layout';
import { FlexColumn } from 'ui-components/components/flex';

import styles from './card-container.module.less';

const getWidth = (isClickable, isFullWidth) => {
  if (isClickable) {
    return ResponsiveWidth.Cols3;
  }
  if (isFullWidth) {
    return ResponsiveWidth.Cols9;
  }
  return ResponsiveWidth.Cols6;
};

const CardContainer = ({
  className = '',
  children,
  disabledTooltipMessage,
  isClickable = false,
  isFullWidth = false,
  isPaymentCard = false,
  position = 'bottom',
  shouldDisableContents = false,
}) => {
  const classNames = classnames(
    styles['card-container'],
    { [styles.clickable]: isClickable },
    { [styles['payment-card']]: isPaymentCard },
    className,
  );

  const zIndex = useMaxZ();
  const zIndexStyle = useMemo(() => ({ zIndex }), [zIndex]);

  return (
    <Tooltip position={position} shouldHideTooltip={!shouldDisableContents}>
      <TooltipContent>{disabledTooltipMessage}</TooltipContent>
      <FlexColumn className={classNames} responsiveWidth={getWidth(isClickable, isFullWidth)}>
        {shouldDisableContents && <div className={styles.overlay} style={zIndexStyle} />}
        {children}
      </FlexColumn>
    </Tooltip>
  );
};

CardContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabledTooltipMessage: PropTypes.node,
  isClickable: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  isPaymentCard: PropTypes.bool,
  position: TooltipPosition,
  shouldDisableContents: PropTypes.bool,
};

export default CardContainer;
